module.exports = __webpack_public_path__ + "2ff8730fe02aeaff2c6bd23f26a781bc.svg";